import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import "./alert.css";
import logoutUser from "./logoutUser";
import "./complaintpaymentdone.css";
import { toWords } from "number-to-words";

function Complaint() {

    const [alertData, setAlertData] = useState(null);
    const showAlert = (message, type = "error") => {
        setAlertData({
            message,
            type,
            id: Date.now()
        });

        setTimeout(() => {
            setAlertData(null);
        }, 5000);
    };

	const [complaintData, setComplaintData] = useState({
	    stream: "",
	    subject: "",
	    bookletSetCode: "",
	    questionNo: "",
	    objectionType: "",
	    complaintDescription: "",
	    hasReferenceDocument: "",
	    document: null
	});
	
	
	const downloadComplaintReport = async () => {

	    try {

	        const token = sessionStorage.getItem("token");

	        const response = await fetch(
	            `${API_BASE_URL}/API/Student/DOWNLOAD_COMPLAINT_REPORT`,
	            {
	                method: "POST",
	                headers: {
	                    "Authorization": "Bearer " + token
	                }
	            }
	        );

	        if (!response.ok) {
	            showAlert("Failed to download report ❗", "error");
	            return;
	        }

	        const blob = await response.blob();

	        const url = window.URL.createObjectURL(blob);

	        const a = document.createElement("a");
	        a.href = url;
	        a.download = "Complaint_Report.pdf";
	        document.body.appendChild(a);
	        a.click();

	        a.remove();
	        window.URL.revokeObjectURL(url);

	    } catch (error) {

	        console.error(error);

	        showAlert("Error downloading report ❗", "error");
	    }
	};
    const validateComplaintData = () => {

		if (selectedProgram === "JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026" && !complaintData.stream) {
		   showAlert("Please select Stream ❗", "error");
		   return false;
		}

        if (!complaintData.subject) {
            showAlert("Please select Subject ❗", "error");
            return false;
        }

        if (!complaintData.bookletSetCode) {
            showAlert("Please select Question Booklet Set Code ❗", "error");
            return false;
        }

        if (!complaintData.questionNo) {
            showAlert("Please select Question No. ❗", "error");
            return false;
        }

        if (!complaintData.objectionType) {
            showAlert("Please select Type of Objection ❗", "error");
            return false;
        }

        if (!complaintData.hasReferenceDocument) {
            showAlert("Please select Yes / No for Reference Document ❗", "error");
            return false;
        }

        if (!complaintData.complaintDescription) {
            showAlert("Please enter Complaint Description ❗", "error");
            return false;
        }

        if (complaintData.hasReferenceDocument === "YES" && !complaintData.document) {
            showAlert("Please upload Reference Document ❗", "error");
            return false;
        }

        const maxSize = 2 * 1024 * 1024;

        if (complaintData.document && complaintData.document.size > maxSize) {
            showAlert("Reference Document size should not exceed 2 MB ❗", "error");
            return false;
        }

        return true;
    };

    const handleSubmitComplaint = async () => {

        if (!validateComplaintData()) return;

        try {

            const token = sessionStorage.getItem("token");

            const formData = new FormData();

            formData.append(
                "complaintData",
                JSON.stringify(complaintData)
            );

            if (complaintData.document) {
                formData.append(
                    "document",
                    complaintData.document
                );
            }

            const response = await fetch(
                `${API_BASE_URL}/API/Student/SAVE_COMPLAINT`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": "Bearer " + token
                    },
                    body: formData
                }
            );

            if (response.status === 401) {

                sessionStorage.clear();

                showAlert(
                    "Session expired ❗ Please login again",
                    "error"
                );

                setTimeout(() => {
                    window.location.href =
                        "/ASTU_JMEE_JLEE/Login";
                }, 1000);

                return;
            }

            const result = await response.text();

            console.log("API Result:", result);

            if (!response.ok) {
                throw new Error(result);
            }

            if (result === "SAVED") {

                showAlert(
                    "Answer key Challenge submitted successfully ✅",
                    "success"
                );

                setComplaintData({
                    stream: selectedStream,
                    subject: "",
                    bookletSetCode: "",
                    questionNo: "",
                    objectionType: "",
                    complaintDescription: "",
                    hasReferenceDocument: "",
                    document: null
                });
				
				fetchOldComplaintDetails();
            }
			
			if (result === "COMPLAINT_ALREADY_REGISTER") {

			    showAlert(
			        "Complaint already registered for this Subject and Question No. ❌",
			        "error"
			    );

			    return;
			}


        } catch (err) {

            console.error(err);

            showAlert(
                "Error submitting complaint ❗",
                "error"
            );
        }
    };

    const [oldComplaintData, setOldComplaintData] = useState([]);
    useEffect(() => {
        fetchOldComplaintDetails();
    }, []);

    const fetchOldComplaintDetails = async () => {

        try {

            const token = sessionStorage.getItem("token");

            const response = await fetch(
                `${API_BASE_URL}/API/Student/GET_OLD_COMPLAINT_DETAILS`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.status === 401) {
                sessionStorage.clear();
                window.location.href = "/ASTU_JMEE_JLEE/Login";
                return;
            }

            const data = await response.json();

            console.log("complaint Data =", data);

            setOldComplaintData(data);

        } catch (error) {
            console.error("Error fetching candidate data:", error);
        }
    };
	
	const feePerComplaint = 500;
	const totalFee = oldComplaintData.length * feePerComplaint;
						
	const handleDeleteComplaint = async (id) => {

	    if (!window.confirm("Are you sure you want to delete this Answer key Challenge ?")) {
	        return;
	    }

	    try {

	        const token = sessionStorage.getItem("token");

	        const response = await fetch(
	            `${API_BASE_URL}/API/Student/DELETE_COMPLAINT/${id}`,
	            {
	                method: "DELETE",
	                headers: {
	                    "Authorization": "Bearer " + token
	                }
	            }
	        );

	        const result = await response.text();

	        if (response.ok) {

	            showAlert("Answer key Challenge deleted successfully", "success");

	            fetchOldComplaintDetails(); // refresh table

	        } else {

	            showAlert(result, "error");
	        }

	    } catch (error) {

	        console.error(error);

	        showAlert("Error deleting complaint", "error");
	    }
	};

	const navigate = useNavigate();
	const [selectedProgram, setSelectedProgram] = useState("");
	useEffect(() => {
			const fetchProgram = async () => {


				try {
					const token = sessionStorage.getItem("token");

					const response = await fetch(
						`${API_BASE_URL}/API/Student/GET_PROGRAM`,
						{
							method: "GET",
							headers: {
								"Authorization": "Bearer " + token
							}
						}
					);

					if (response.status === 401 || response.status === 403) {

						logoutUser(navigate);
						return;
					}

					if (!response.ok) {
						console.error("Failed to fetch program");
						return;
					}

					//if (!response.ok) return;

					const data = await response.text(); // since backend returns string
					console.log("selected program is:", data);

					if (data) {
						setSelectedProgram(data); // ✅ auto select
					}

				} catch (err) {
					console.error("Failed to fetch program", err);
				}
			};

			fetchProgram();
		}, []);


		

		const [selectedStream, setSelectedStream] = useState("");

		useEffect(() => {

		    const fetchStream = async () => {

		        try {

		            const token = sessionStorage.getItem("token");

		            const response = await fetch(
		                `${API_BASE_URL}/API/Student/GET_STREAM`,
		                {
		                    method: "GET",
		                    headers: {
		                        Authorization: `Bearer ${token}`
		                    }
		                }
		            );

		            const stream = await response.text();

		            console.log("Stream:", stream);

		            setSelectedStream(stream);

		            setComplaintData(prev => ({
		                ...prev,
		                stream: stream
		            }));

		        } catch (error) {
		            console.error("Error fetching stream:", error);
		        }

		    };

		    fetchStream();

		}, []);
		
		
		const [isPaymentDoneComplaint, setIsPaymentDoneComplaint] = useState(false);

			useEffect(() => {
				const checkPaymentStatus = async () => {
					try {
						const token = sessionStorage.getItem("token");

						const response = await fetch(
							`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT_FOR_COMPLAINT`,
							{
								method: "GET",
								headers: {
									"Authorization": "Bearer " + token
								}
							}
						);

						if (response.status === 401 || response.status === 403) {

							logoutUser(navigate);
							return;
						}

						if (!response.ok) {
							console.error("Failed to fetch program");
							return;
						}


						if (!response.ok) return;

						const result = await response.json(); // boolean true/false
						console.log("Payment Done:", result);

						setIsPaymentDoneComplaint(result);

						if (result) {
							showAlert(
								"Payment already completed ✅. Please download the Provisional Answer Key Challenge Report Print-Out.",
								"success"
							);

							
						}

					} catch (error) {
						console.error("Error checking payment:", error);
					}
				};

				checkPaymentStatus();
			}, []);

			if (isPaymentDoneComplaint) {
			    return (
			        <>
			            {alertData && (
			                <div className={`custom-alert ${alertData.type}`}>
			                    <span className="alert-icon">
			                        {alertData.type === "success" ? "✔" : "❗"}
			                    </span>
			                    {alertData.message}
			                </div>
			            )}

			            <div className="payment-success-wrapper">
			                <div className="payment-success-card">

			                    <div className="success-icon">
			                        <i className="fas fa-check-circle"></i>
			                    </div>

			                    <h2>Challenge Fee, Payment Successful</h2>

			                    <p>
			                        Your challenge has been submitted successfully.
			                        The payment has been received and your objections are under review.
			                    </p>

								<button
								    className="download-report-btn"
								    onClick={downloadComplaintReport}
								>
								    <i className="fas fa-download"></i>
								    Download Challenge to Provisional Answer Key Report
								</button>

			                </div>
			            </div>
			        </>
			    );
			}
			
    return (


        <>
            <style>
                {`
                .complaint-container{
                    padding:20px;
                }

                .complaint-card{
                    background:#fff;
                    border:1px solid #d9e2ec;
                    border-radius:10px;
                    padding:25px;
                    box-shadow:0 2px 8px rgba(0,0,0,0.08);
                }

				.complaint-container{
				    padding:10px;
				}

				.complaint-card{
				    padding:15px;
				    border-radius:8px;
				}

				.complaint-title{
				    color:#00695c;
				    font-size:18px;
				    font-weight:600;
				    margin-bottom:12px;
				}

				.form-group{
				    margin-bottom:10px;
				}

				.form-group label{
				    display:block;
				    font-size:12px;
				    font-weight:600;
				    color:#00695c;
				    margin-bottom:3px;
				}

				.form-control{
				    width:100%;
				    padding:6px 8px;
				    border:1px solid #cfd8dc;
				    border-radius:4px;
				    font-size:12px;
				    box-sizing:border-box;
				}

				.form-control:focus{
				    outline:none;
				    border-color:#009688;
				}

				.radio-group{
				    display:flex;
				    gap:12px;
				    margin-top:3px;
				}

				.radio-group label{
				    color:#000;
				    font-size:12px;
				}

				.btn-section{
				    text-align:right;
				    margin-top:15px;
				}

				.submit-btn{
				    background:#0b8f61;
				    color:white;
				    border:none;
				    padding:6px 18px;
				    border-radius:4px;
				    font-size:12px;
				    font-weight:600;
				    cursor:pointer;
				}

				.submit-btn:hover{
				    background:#087a52;
				}

				.exam-section-box{
				    background:#f1f8f7;
				    border:1px solid #b2dfdb;
				    border-radius:6px;
				    padding:8px;
				    margin-bottom:12px;
				}

				.exam-section-title{
				    color:#00695c;
				    font-size:12px;
				    font-weight:700;
				    margin-bottom:4px;
				}

				.exam-section-row{
				    font-size:11px;
				    color:#333;
				    margin-bottom:2px;
				}
				.instruction-panel{
				    margin-top:30px;
				    margin-bottom:25px;   /* Space before button */
				    background:#f8fafc;
				    border:1px solid #dbe4ee;
				    border-left:6px solid #0b8f61;
				    border-radius:8px;
				    padding:18px 22px;
				    box-shadow:0 2px 8px rgba(0,0,0,0.05);
				}

				.instruction-header{
				    display:flex;
				    align-items:center;
				    gap:10px;
				    margin-bottom:15px;
				    padding-bottom:10px;
				    border-bottom:1px solid #e5e7eb;
				}

				.instruction-header i{
				    color:#0b8f61;
				    font-size:20px;
				}

				.instruction-title{
				    font-size:17px;
				    font-weight:700;
				    color:#0b8f61;
				    margin:0;
				}

				.instruction-list{
				    margin:0;
				    padding-left:22px;
				}

				.instruction-list li{
				    margin-bottom:12px;
				    line-height:1.7;
				    font-size:13px;
				    color:#333;
				    text-align:justify;
				}

				.instruction-list li strong{
				    color:#c62828;
				}

				.note-box{
				    margin-top:15px;
				    background:#fff3cd;
				    border:1px solid #ffeeba;
				    border-radius:6px;
				    padding:12px;
				    font-size:13px;
				    color:#856404;
				    font-weight:600;
				}

				/* Extra space before submit button */
				.btn-section{
				    text-align:right;
				    margin-top:35px !important;
				}
				.complaint-history-card{
				    margin-top:25px;
				    background:#fff;
				    border:1px solid #dbe4ee;
				    border-radius:8px;
				    padding:15px;
				    box-shadow:0 2px 8px rgba(0,0,0,0.05);
				}

				.history-title{
				    font-size:16px;
				    font-weight:700;
				    color:#00695c;
				    margin-bottom:15px;
				    border-bottom:2px solid #e0e0e0;
				    padding-bottom:8px;
				}

				.table-responsive{
				    overflow-x:auto;
				}

				.complaint-table{
				    width:100%;
				    border-collapse:collapse;
				    min-width:900px;
				}

				.complaint-table thead th{
				    background:#00695c;
				    color:#fff;
				    padding:10px;
				    text-align:center;
				    font-size:13px;
				    border:1px solid #ddd;
				}

				.complaint-table tbody td{
				    padding:10px;
				    border:1px solid #ddd;
				    font-size:12px;
					text-align:center;      
					vertical-align:middle;
				}

				.complaint-table tbody tr:nth-child(even){
				    background:#f8f9fa;
				}

				.complaint-table tbody tr:hover{
				    background:#eef7f6;
				}

				.no-data{
				    text-align:center;
				    font-weight:600;
				    color:#888;
				    padding:20px;
				}
				.delete-btn{
				    display:inline-flex;
				    align-items:center;
				    gap:6px;
				    padding:5px 12px;
				    border:none;
				    border-radius:5px;
				    background:#dc3545;
				    color:#fff;
				    font-size:12px;
				    font-weight:600;
				    cursor:pointer;
				    transition:all 0.25s ease;
				    box-shadow:0 2px 6px rgba(220,53,69,0.25);
				}

				.delete-btn i{
				    font-size:11px;
				}

				.delete-btn:hover{
				    background:#c82333;
				    transform:translateY(-1px);
				    box-shadow:0 4px 10px rgba(220,53,69,0.35);
				}

				.delete-btn:active{
				    transform:translateY(0);
				}

				.delete-btn:disabled{
				    opacity:0.6;
				    cursor:not-allowed;
				}
				.delete-icon-btn{
				    width:34px;
				    height:34px;
				    border:none;
				    border-radius:50%;
				    background:#fff1f2;
				    color:#dc3545;
				    cursor:pointer;
				    transition:all .25s ease;
				}

				.delete-icon-btn:hover{
				    background:#dc3545;
				    color:#fff;
				    transform:scale(1.08);
				}

				.payment-bar {
				    margin-top: 15px;
				    background: #fff8e1;
				    border: 1px solid #ffd54f;
				    border-radius: 6px;
				    padding: 14px 20px;

				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				}

				.payment-label {
				    font-size: 18px;
				    font-weight: 700;
				    color: #5d4037;
				    display: block;
				}

				.payment-amount-words {
				    margin-top: 4px;
				    font-size: 13px;
				    font-weight: 600;
				    color: #666;
				    text-transform: uppercase;
				}

				.payment-amount {
				    font-size: 26px;
				    font-weight: 800;
				    color: #d32f2f;
				}
				
                `}
            </style>

            {alertData && (
                <div className={`custom-alert ${alertData.type}`}>
                    <span className="alert-icon">
                        {alertData.type === "success" ? "✔" : "❗"}
                    </span>
                    {alertData.message}
                </div>
            )}
			
			

            <div className="complaint-container">
                <div className="complaint-card">

                    <div className="complaint-title">
                        Challenge to Provisional Answer Key
                    </div>

					<div className="exam-section-box">

					    <div className="exam-section-title">
					        Examination Sections
					    </div>

					    {selectedProgram === "JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026" ? (
					        <>
					            <div className="exam-section-row">
					                <strong>Section - I :</strong> Mathematics (Q1 to Q30)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - II :</strong> Reasoning (Q31 to Q60)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - III :</strong> English (Q61 to Q80)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - IV :</strong> Fundamentals of Computers (Q81 to Q100)
					            </div>
					        </>
					    ) : (
					        <>
					            <div className="exam-section-row">
					                <strong>Section - I :</strong> Mathematics (Q1 to Q30)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - II :</strong> Basic of Computer Science (Q31 to Q40)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - III :</strong> Engineering Graphics (Q41 to Q50)
					            </div>

					            <div className="exam-section-row">
					                <strong>Section - IV :</strong> Branch of Engineering (Q51 to Q100)
					            </div>
					        </>
					    )}

					</div>
					{selectedProgram === "JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026" && (
					    <div className="form-group">
					        <label>Stream *</label>

					        <select
					            className="form-control"
					            value={complaintData.stream}
					            onChange={(e) =>
					                setComplaintData({
					                    ...complaintData,
					                    stream: e.target.value
					                })
					            }
					        >
					            <option value="">Select Stream</option>

					            {selectedStream && (
					                <option value={selectedStream}>
					                    {selectedStream}
					                </option>
					            )}
					        </select>
					    </div>
					)}

					<div className="form-group">
					    <label>Complaint Subject *</label>
					    <select
					        className="form-control"
					        value={complaintData.subject}
					        onChange={(e) =>
					            setComplaintData({
					                ...complaintData,
					                subject: e.target.value,
					                questionNo: ""
					            })
					        }
					    >
					        <option value="">Select Subject</option>

					        {selectedProgram?.trim() === "JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026" ? (
					            <>
					                <option value="Mathematics">Mathematics</option>
					                <option value="Reasoning">Reasoning</option>
					                <option value="English">English</option>
					                <option value="Fundamentals of Computers">
					                    Fundamentals of Computers
					                </option>
					            </>
					        ) : (
					            <>
					                <option value="Mathematics">Mathematics</option>
					                <option value="Basic of Computer Science">
					                    Basic of Computer Science
					                </option>
					                <option value="Engineering Graphics">
					                    Engineering Graphics
					                </option>
					                <option value="Branch of Engineering">
					                    Branch of Engineering
					                </option>
					            </>
					        )}
					    </select>
					</div>

                    <div className="form-group">
                        <label>Question Booklet Set Code *</label>
                        <select
                            className="form-control"
                            value={complaintData.bookletSetCode}
                            onChange={(e) =>
                                setComplaintData({
                                    ...complaintData,
                                    bookletSetCode: e.target.value
                                })
                            }
                        >
                            <option value="">Select Set Code</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                        </select>
                    </div>

					<div className="form-group">
					    <label>Please Select Question No. *</label>

					    <select
					        className="form-control"
					        value={complaintData.questionNo}
					        onChange={(e) =>
					            setComplaintData({
					                ...complaintData,
					                questionNo: e.target.value
					            })
					        }
					    >
					        <option value="">Select Question No.</option>

					        {selectedProgram === "JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026" ? (
					            <>
					                {complaintData.subject === "Mathematics" &&
					                    Array.from({ length: 30 }, (_, i) => (
					                        <option key={i + 1} value={`Q${i + 1}`}>
					                            Q{i + 1}
					                        </option>
					                    ))}

					                {complaintData.subject === "Reasoning" &&
					                    Array.from({ length: 30 }, (_, i) => (
					                        <option key={i + 31} value={`Q${i + 31}`}>
					                            Q{i + 31}
					                        </option>
					                    ))}

					                {complaintData.subject === "English" &&
					                    Array.from({ length: 20 }, (_, i) => (
					                        <option key={i + 61} value={`Q${i + 61}`}>
					                            Q{i + 61}
					                        </option>
					                    ))}

					                {complaintData.subject === "Fundamentals of Computers" &&
					                    Array.from({ length: 20 }, (_, i) => (
					                        <option key={i + 81} value={`Q${i + 81}`}>
					                            Q{i + 81}
					                        </option>
					                    ))}
					            </>
					        ) : (
					            <>
					                {complaintData.subject === "Mathematics" &&
					                    Array.from({ length: 30 }, (_, i) => (
					                        <option key={i + 1} value={`Q${i + 1}`}>
					                            Q{i + 1}
					                        </option>
					                    ))}

					                {complaintData.subject === "Basic of Computer Science" &&
					                    Array.from({ length: 10 }, (_, i) => (
					                        <option key={i + 31} value={`Q${i + 31}`}>
					                            Q{i + 31}
					                        </option>
					                    ))}

					                {complaintData.subject === "Engineering Graphics" &&
					                    Array.from({ length: 10 }, (_, i) => (
					                        <option key={i + 41} value={`Q${i + 41}`}>
					                            Q{i + 41}
					                        </option>
					                    ))}

					                {complaintData.subject === "Branch of Engineering" &&
					                    Array.from({ length: 50 }, (_, i) => (
					                        <option key={i + 51} value={`Q${i + 51}`}>
					                            Q{i + 51}
					                        </option>
					                    ))}
					            </>
					        )}
					    </select>
					</div>

                    <div className="form-group">
                        <label>Question: Type of Objection *</label>

                        <select
                            className="form-control"
                            value={complaintData.objectionType}
                            onChange={(e) =>
                                setComplaintData({
                                    ...complaintData,
                                    objectionType: e.target.value
                                })
                            }
                        >
                            <option value="" disabled selected>Select</option>

                            <option value="Question is incorrect">
                                Question is incorrect
                            </option>

                            <option value="Data provided in the question is incomplete">
                                Data provided in the question is incomplete
                            </option>

                            <option value="More than one option is correct">
                                More than one option is correct
                            </option>

                            <option value="None of the options given is correct">
                                None of the options given is correct
                            </option>

                            <option value="Answer key of the question is incorrect">
                                Answer key of the question is incorrect
                            </option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Complaint Description *</label>

                        <textarea
                            rows="5"
                            className="form-control"
                            placeholder="Describe your issue"
                            value={complaintData.complaintDescription}
                            onChange={(e) =>
                                setComplaintData({
                                    ...complaintData,
                                    complaintDescription: e.target.value
                                })
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label>Upload Reference Document (If Any) (Only .pdf) *</label>

                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    name="hasReferenceDocument"
                                    value="YES"
                                    checked={complaintData.hasReferenceDocument === "YES"}
                                    onChange={(e) =>
                                        setComplaintData({
                                            ...complaintData,
                                            hasReferenceDocument: e.target.value
                                        })
                                    }
                                />
                                Yes
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="hasReferenceDocument"
                                    value="NO"
                                    checked={complaintData.hasReferenceDocument === "NO"}
                                    onChange={(e) =>
                                        setComplaintData({
                                            ...complaintData,
                                            hasReferenceDocument: e.target.value,
                                            document: null
                                        })
                                    }
                                />
                                No
                            </label>
                        </div>
                    </div>

                   {/* {complaintData.hasReferenceDocument === "YES" && (
                        <div className="form-group">
                            <label>Reference Document (.jpg / .jpeg)</label>

                            <input
                                type="file"
                                accept=".jpg,.jpeg,image/jpeg"
                                className="form-control"
                                onChange={(e) =>
                                    setComplaintData({
                                        ...complaintData,
                                        document: e.target.files[0]
                                    })
                                }
                            />
                        </div>
                    )}*/}
					
					{complaintData.hasReferenceDocument === "YES" && (
					    <div className="form-group">
					        <label>Reference Document (.pdf)</label>

					        <input
					            type="file"
					            accept=".pdf,application/pdf"
					            className="form-control"
								onChange={(e) => {

								    const file = e.target.files[0];

								    if (file && file.type !== "application/pdf") {
								        showAlert("Only PDF files are allowed ❗", "error");
								        e.target.value = "";
								        return;
								    }

								    setComplaintData({
								        ...complaintData,
								        document: file
								    });
								}}
					        />
					    </div>
					)}

                    {/*<div className="form-group">
                        <label>Priority *</label>

                        <div className="radio-group">
                            <label>
                                <input type="radio" name="priority" /> Low
                            </label>

                            <label>
                                <input type="radio" name="priority" /> Medium
                            </label>

                            <label>
                                <input type="radio" name="priority" /> High
                            </label>
                        </div>
                    </div>*/}

                    <div className="btn-section">
                        <button
                            className="submit-btn"
                            onClick={handleSubmitComplaint}
                        >
                            Submit Complaint
                        </button>
                    </div>

                    <div className="instruction-panel">

                        <div className="instruction-header">
                            <i className="fas fa-info-circle"></i>
                            <h4 className="instruction-title">
                                Instructions for Provisional Answer Key Challenge
                            </h4>
                        </div>

                        <ol className="instruction-list">

                            <li>
                                The Provisional Answer Keys will be uploaded on the official website
                                <strong> www.astu.ac.in </strong>
                                after <strong>07:00 PM on 22nd June, 2026</strong>.
                            </li>

                            <li>
                                Challenge(s) to the Provisional Answer Keys can be submitted up to
                                <strong> 07:00 PM on 24th June, 2026</strong>.
                            </li>

                            <li>
                                The challenges to provisional answer key, by the appeared candidates, will be accepted
                                only through the online link available on the website
                                <strong> www.astu.ac.in </strong> or <strong> JLEE/JMEE-2026 Login Portal</strong>.
                            </li>

                            <li>
                                The subject experts will examine all the challenges received and the final answer key
                                will be displayed in the website <strong> (www.astu.ac.in) </strong>
                            </li>

                            <li>
                                All challenges received shall be examined by subject experts and the
                                Final Answer Key will be published on the University's website.
                            </li>

                            <li>
                                The results will be compiled on the basis of the final answer key. No further
                                communication in connection to answer key(s) will be entertained after
                                after <strong>07:00 PM on 24th June, 2026</strong>.
                            </li>

                            <li>
                                The challenge(s) to Provisional Answer Keys will be accepted online only through
                                <strong>"JLEE/JMEE-2026" login portal </strong>
                                available in the official website of the university
                                <strong> (www.astu.ac.in) </strong> on successful payment of a processing fee of
                                <strong> Rs. 500/- (Five Hundred only) per question.</strong>
                                The fee will be refunded, if the answer key challenge is sustained.
                            </li>

                            <li>
                                Provisional Answer Key challenge(s) with successful payment of requisite fees will only be considered for further processing.
                            </li>

                            <li>
                                Candidate must verify the <strong>"Payable Amount" </strong> before payment of fees.
                            </li>

                            <li>
                                Decision of the University on the challenges shall be final and no further communication will be entertained.
                            </li>
                        </ol>

                        <div className="note-box">
                            ⚠ Please read all instructions carefully before submitting your challenge.
                        </div>

                    </div>
					
					<div className="complaint-history-card">

					    <div className="history-title">
					        Challenge to Provisional Answer Key Details
					    </div>

					    <div className="table-responsive">
					        <table className="complaint-table">

					            <thead>
					                <tr>
					                    <th>Sr. No.</th>
										<th>Complaint ID</th>
					                    <th>Stream</th>
					                    <th>Complaint Subject</th>
					                    <th>Booklet Set Code</th>
					                    <th>Question No.</th>
										<th>Type of Objection</th>
					                    <th>Complaint Description</th>
										<th>Upload Reference Document</th>
										<th>Reference Document</th>
										<th>Action</th>
					                </tr>
					            </thead>

					            <tbody>

					                {oldComplaintData.length > 0 ? (

					                    oldComplaintData.map((item, index) => (

					                        <tr key={item.id || index}>
					                            <td>{index + 1}</td>
												<td>{item.id}</td>
					                            <td>{item.stream}</td>
					                            <td>{item.subject}</td>
					                            <td>{item.booklet_set_code}</td>
					                            <td>{item.question_no}</td>
												<td>{item.objection_type}</td>
					                            <td>{item.complaint_description}</td>
												<td>{item.has_reference_document}</td>
												<td>
												    {item.document_base64 ? (
												        <button
												            type="button"
												            onClick={() => {
												                const byteCharacters = atob(item.document_base64);
												                const byteNumbers = new Array(byteCharacters.length);

												                for (let i = 0; i < byteCharacters.length; i++) {
												                    byteNumbers[i] = byteCharacters.charCodeAt(i);
												                }

												                const byteArray = new Uint8Array(byteNumbers);

																const blob = new Blob([byteArray], {
																    type: "application/pdf"
																});

																const url = URL.createObjectURL(blob);

																window.open(url, "_blank");
												            }}
												        >
												            View Document
												        </button>
												    ) : (
												        "-"
												    )}
												</td>
												<td>
												    <button
												        type="button"
												        className="delete-btn"
												        onClick={() => handleDeleteComplaint(item.id)}
												    >
												        <i className="fas fa-trash-alt"></i>
												        Delete
												    </button>
												</td>
					                        </tr>

					                    ))

					                ) : (

					                    <tr>
					                        <td colSpan="10" className="no-data">
					                            No Complaint Found
					                        </td>
					                    </tr>

					                )}

					            </tbody>

					        </table>
					    </div>

					</div>
					
					

					<div className="payment-bar">
					    <div>
					        <span className="payment-label">
					            Total Payable Amount
					        </span>

					        <div className="payment-amount-words">
					            ({toWords(totalFee).toUpperCase()} RUPEES ONLY)
					        </div>
					    </div>

					    <span className="payment-amount">
					        ₹ {totalFee}/-
					    </span>
					</div>
					
					<div
					    style={{
					        marginTop: "15px",
					        textAlign: "center"
					    }}
					>
					    <a
					        href="https://www.onlinesbi.sbi/sbicollect/icollecthome.htm?corpID=880654"
					        target="_blank"
					        rel="noopener noreferrer"
					        className="submit-btn"
					        style={{
					            textDecoration: "none",
					            display: "inline-block",
					            padding: "10px 25px"
					        }}
					    >
					        Proceed to Payment
					    </a>
					</div>

                </div>


            </div>
        </>
    );
}

export default Complaint;